import { VaultAnalyzeCompleteStatus } from "./VaultAnalyzeCompleteStatus";
import { VaultInProgressStatus } from "./VaultInProgressStatus"

export const VaultStatusMap = (status, minimized = false) => {
    switch (status) {
        case "Done":
            return <VaultAnalyzeCompleteStatus minimized={minimized} />;
        default:
            return <VaultInProgressStatus minimized={minimized} />
    }
}